import React, { FC } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react.js';
import { EffectCards, Pagination } from 'swiper';
import { replaceHtmlEntities } from '@src/util/replaceHtmlEntities';
import { Image } from '@src/components/Image';
import './styles.scss';

export const SnippetSwiper: FC = () => {
  const snippets = [
    {
      imageUrl: 'https://meetfrank-static-media.s3.amazonaws.com/images/team.jpg',
      text: 'In Acme Inc. you can take charge of problems, guide your work, and leave your mark. Enjoy great mission, a supportive team, and flexible work options.',
      title: 'Innovation through people',
    },
    {
      imageUrl: 'https://meetfrank-static-media.s3.amazonaws.com/images/office.jpg',
      text: 'Join Acme, a Glocal leader in assets, banking, clean energy, medical innovation and space technology.',
      title: 'Industry Leader',
    },
    {
      text: 'Free lunch, extra holidays, dental plan, insurance, company car, sports facilities, you name it.',
      title: 'Awesome Perks',
    },
  ];

  return (
    <div className="preview-snippet-slider">
      <Swiper
        allowTouchMove={true}
        centeredSlides={false}
        mousewheel={true}
        modules={[EffectCards, Pagination]}
        onSlideChange={swiper => {
          swiper.update();
        }}
        creativeEffect={{
          next: {
            scale: 0.92,
            translate: ['100%', 0, 0],
          },
          prev: {
            shadow: false,
            translate: [0, 0, -400],
          },
        }}
        pagination={{
          bulletActiveClass: 'preview-snippet-slider__bullet-active',
          bulletClass: 'preview-snippet-slider__bullet',
          el: '.preview-snippet-slider__pagination',
        }}
        effect={'creative'}
        loop={true}
        spaceBetween={16}
      >
        {snippets.map((snippet, index) => {
          return (
            <SwiperSlide key={index}>
              <div className="preview-snippet-slider__card-wrapper">
                <div className="preview-snippet-slider__item">
                  <div className="preview-snippet-slider__item-top">
                    <div className="preview-snippet-slider__header">
                      <span className="preview-snippet-slider__title">{replaceHtmlEntities(snippet.title, false)}</span>

                      <span className="preview-snippet-slider__label">frank ai</span>
                    </div>

                    <div className="preview-snippet-slider__text">{replaceHtmlEntities(snippet.text, false)}</div>
                  </div>

                  {snippet.imageUrl && <Image className="preview-snippet-slider__image" src={snippet.imageUrl} />}
                </div>
              </div>
            </SwiperSlide>
          );
        })}

        <div className="preview-snippet-slider__footer">
          <div className="preview-snippet-slider__pagination-wrapper">
            <div className="preview-snippet-slider__pagination" />
          </div>

          <div className="preview-snippet-slider__item-actions">
            <span className="preview-snippet-slider__actions-apply">View or apply</span>
          </div>
        </div>
      </Swiper>
    </div>
  );
};
